<template>
  <div class="wrapper_mj">
    <!--密卷会员专享 -->
    <adModel v-if="options.img" :options="options" :show="miSvip" />
    <van-overlay v-else :show="miSvip" class="downLoad_wrapper" :lock-scroll="false">
      <div class="down">
        <img
          class="download"
          src="https://img.yzcdn.cn/upload_files/2020/06/09/FpMt9m18wwtv7WNH0eygqAEOiLCc.png"
        />
        <div class="cont">
          <div class="vip_title">会员专属特权</div>
          <div class="open">开通会员继续使用密卷</div>
          <div class="btn" @click="toVip">开通会员</div>
          <div class="x_title" @click="closeMj">暂不开通</div>
        </div>
        <div>
          <img
            class="close"
            src="https://img.yzcdn.cn/upload_files/2019/11/25/Fs53hUSGrw074xduGjRxvDIQSTYd.png"
            @click="closeMj"
          />
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { adModel } from '../../../../../library'
import { getMopaAd } from '@/api/ad'
export default {
  name: '',
  components: {
    adModel: adModel.component
  },

  props: {
    miSvip: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      options: {
        img: '',
        link: '',
        ad: false,
        close: () => {
          this.closeMj()
        }
      }
    }
  },
  mounted() {
    getMopaAd(
      {
        code: 'mjBook', // 页面
        cCodes: 'mjbook_iconpopup' // 页面位置
      },
      this.$store.userInfo.vipLevel.toUpperCase(),
      this.$env.isIos
    ).then((res) => {
      if (res.length > 0) {
        this.options.img = res[0].imgPath
        this.options.link = res[0].urlPath
        this.options.ad = res[0].externalOrg
      }
    })
  },
  methods: {
    closeMj() {
      this.$emit('closeMj')
    },
    toVip() {
      this.$emit('toVip')
    }
  }
}
</script>

<style lang="scss" scroped>
.wrapper_mj {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  .block {
    width: 6.67rem;
    height: 8rem;
    background: rgba(255, 255, 255, 1);
    border-radius: 0.27rem;
    img {
      width: 100%;
    }
    .msg {
      width: 100%;
      text-align: center;
      margin-top: 0.4rem;
      .msg_top {
        font-size: 0.45rem;
        font-weight: 400;
        color: rgba(0, 0, 0, 1);
        margin-bottom: 0.27rem;
      }
      .msg_bottom {
        width: 5.8rem;
        margin: 0 auto;
        margin-bottom: 0.59rem;
        font-size: 0.35rem;
        font-weight: 400;
        color: rgba(127, 127, 127, 1);
      }
      button {
        width: 3.47rem;
        height: 0.96rem;
        background: linear-gradient(90deg, rgba(255, 139, 62, 1) 0%, rgba(239, 66, 70, 1) 100%);
        border-radius: 0.53rem;
        font-size: 0.35rem;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
      }
    }
  }
}
.downLoad_wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
  .down {
    position: relative;
  }
  img {
    width: 7.49rem;
  }
  .close {
    width: 0.75rem;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    padding-top: 0.53rem;
  }
  .cont {
    width: 100%;
    position: absolute;
    text-align: center;
    top: 3.76rem;
    .vip_title {
      color: #333333;
      font-size: 0.48rem;
    }
    .open {
      color: #999999;
      font-size: 0.37rem;
      margin-top: 0.25rem;
    }
    .btn {
      width: 5.41rem;
      height: 1.04rem;
      background: linear-gradient(90deg, rgba(246, 228, 199, 1), rgba(254, 217, 148, 1));
      border-radius: 0.52rem;
      font-size: 0.4rem;
      line-height: 1.04rem;
      color: rgba(96, 56, 26, 1);
      margin: 0 auto;
      margin-top: 0.77rem;
    }
    .x_title {
      font-size: 0.32rem;
      text-decoration: underline;
      color: rgba(153, 153, 153, 1);
      margin-top: 0.43rem;
    }
  }
}
</style>
